<template>
<div>
	<div>
		{{ nix }}
	</div>
</div>

</template>

<script>
	import store from 'root/store.js'
	import { authCheck } from 'functions/auth_check.js'

	export default {
      beforeRouteEnter (to, from, next) {
        const route = authCheck('templates')
        if (route === null) {
          next()
        } else {
          next(route)
        }
      },

		beforeRouteLeave(to, from, next) {
			if (to.path === '/'+this.model.name+'/new') {
				this.model.clear()
			}
			next()
		},

		// Normale Eigenschaften
		data () {
			return {
				nix: 'nix'
			}
		}
	}
</script>



// WEBPACK FOOTER //
// TemplateEdit.vue?9775f1e2